import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { userFullName } from "helpers/common";
import PDFHtmlRenderer from "./PDFHtmlRenderer";

const styles = StyleSheet.create({
  mainHeading: {
    fontSize: 10,
    fontWeight: 'semibold',
    fontFamily: 'Proxima Nova',
  },
  border: {
    borderBottom: "1px solid #000",
    paddingBottom: "2px",
    marginBottom: "8px"
  },
  mainSubHeading: {
    fontSize: 8,
    fontWeight: 'semibold',
    fontFamily: 'Proxima Nova',
    letterSpacing: "1px",
    textTransform: "uppercase"
  },
});

const OtherTherapistSignaturePdf = ({ data }) => {
  return (
    data?.otherTherapists?.map((item, index) => <View style={{ marginTop: 20 }}>
      <View style={{ gap: "1px" }}>
        <View>
          {
            item?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.signature_img &&
            <Image style={{ width: "50%" }} src={item?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.signature_img} />
          }
        </View>
           <PDFHtmlRenderer
            style={{ fontSize: 8 }}
            stylesheet={{
              p: { marginBottom: 0, marginTop: 0 },
            }}
            data={item?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.email_signature || ""}
          />
        {/* <Text style={{ fontSize: 8 }}>{item?.clientCaseloadMapping?.[0]?.caseTherapist?.therapist_detail?.email_signature}</Text> */}
        {/* <Text style={{ fontSize: 8 }}>{`Clinician Supervisor`}</Text>
        <Text style={{ fontSize: 8, color: "#315D99", textDecoration: "underline" }}>{data?.therapist?.email}</Text>
        <Text style={{ fontSize: 8 }}>{data?.therapist?.phone}</Text> */}
      </View>
    </View>)
  )
}

export default OtherTherapistSignaturePdf;